<style scoped>
    .canvas-row {
        text-align: center;
    }
</style>
<template>
    <div class="pdf-document">
        <v-row justify="center">
            <v-col cols="12">
                <pagination-component v-model="currentPage" :length="maxPage"></pagination-component>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12" class="canvas-row">
                <pdf-page-component
                    v-for="page in pages"
                    v-bind="{page, scale}"
                    :key="page.pageNumber"
                ></pdf-page-component>
            </v-col>
        </v-row>
        <v-row justify="center">
            <v-col cols="12">
                <pagination-component v-model="currentPage" :length="maxPage"></pagination-component>
            </v-col>
        </v-row>
    </div>
</template>

<script>
/* eslint-disable */
/*
export default {
name: 'WebViewer',
props: {
path: String,
url: String
},
mounted: function () {
WebViewer({
path: this.path,
initialDoc: this.url, // replace with your own PDF file
}, this.$refs.viewer).then((instance) => {
// call apis here
});
}
}
*/
//import pdfjsLib from 'pdfjs-dist/webpack';
//import * as pdfjsLib from 'pdfjs-dist/webpack';
import range from 'lodash/range';
import * as pdfjsLib from 'pdfjs-dist';
//import { PDFViewer } from "pdfjs-dist/web/pdf_viewer";
import "pdfjs-dist/web/pdf_viewer.css";
export default {
    props: {
            url: {
                type: String,
            },
            scale: {
                type: String,
            },
            // pdf.worker.jsのパスを指定
            pdfWorkerPath: {
                type: String,
                default: "/documents/js/pdf.worker.js"
            },
    },
    data() {
        return {
            currentUrl: this.url,
            pdf: undefined,
            pages: [],
            maxPage: 0,
            currentPage: 1,
        };
    },
    created() {
        // 指定したパスにない場合は/js/pdf.worker.jsになる模様
        pdfjsLib.GlobalWorkerOptions.workerSrc = this.pdfWorkerPath;
        this.fetchPDF();
    },
    methods: {
        // pdfの読み込み
        async fetchPDF() {
            if (!this.currentUrl) {
                return;
            }
            let loadingTask = pdfjsLib.getDocument({
                  url: this.currentUrl,
                  cMapUrl: '/documents/cmaps/',
                  cMapPacked: true,
              });
            let loadpdf = await loadingTask.promise;
            this.pdf = loadpdf;
            this.maxPage = loadpdf.numPages;
        },
        // 最初のページへ
        isFirst() {
            return this.currentPage <= 1; 
        },
        // 最後のページへ
        isEnd() {
            return this.currentPage >= this.maxPage;
        },
        // 前のページへ
        prev() {
            if (this.currentPage > 1) {
                this.currentPage -= 1;
            }
        },
        // 次のページへ
        next() {
            if (this.currentPage < this.maxPage) {
                this.currentPage += 1;
            }
        }
    },
    watch: {
       url(url) {
            //外部から指定されたURLが変更になった時に再描画をおこなう
            this.currentUrl = url;
            this.currentPage = 1;
            this.fetchPDF();
        },
        // pdfオブジェクト
        pdf(pdf) {
            this.pages = [];
            Promise.all([pdf.getPage(this.currentPage)]).
            then(pages => (this.pages = pages));
        },
        // 現在のページ
        currentPage(pageNum) {
          // ページ切り替えの際に埋め込み画像等が消える問題があったため、保持しているPDFデータを都度読み込み直す
          var my = this;
          this.pdf.getData().then(async function(arrayBuffer) {
            let loadingTask = pdfjsLib.getDocument({
                data: arrayBuffer,
                cMapUrl: '/documents/cmaps/',
                cMapPacked: true,
            });
            my.pdf = await loadingTask.promise;
            await my.pdf.getPage(pageNum);
          });
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    div.pdf-document{
        width: 100%; 
        height: 100vh;
    }
</style>